import type { WidgetConfig } from '@/types/config';
import type { EventBus } from '@/core/EventBus';

/**
 * Base class for widget modes
 */
export abstract class BaseMode {
  constructor(
    protected config: WidgetConfig,
    protected eventBus: EventBus
  ) {}

  /**
   * Render the widget mode
   */
  abstract render(): void;

  /**
   * Cleanup and destroy the widget mode
   */
  abstract cleanup(): void;

  /**
   * Generate unique ID for elements
   */
  protected generateId(prefix: string): string {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
